import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class FormDoneService {

  private _token: string = localStorage.getItem('token');

  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) { }

  getFormData(token): Observable<any> {
    const headers = new Headers({ 'Authorization': token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'academicinfo/get-form-data', options).map((res => res.json()))
    .catch(this.handleErrorObservable);
  }

  getFormData$(): Observable<any> {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'academicinfo/get-form-data', options).map((res => res.json()))
    .catch(this.handleErrorObservable);
  }

  getHeaderData$(name): Observable<any> {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'partner/get-partner-logos/' + name, options).map((res => res.json()))
    .catch(this.handleErrorObservable);
  }

  getDomainList$(): Observable<any> {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'partner/get-domain-list', options).map((res => res.json()))
    .catch(this.handleErrorObservable);
  }

  getPartnerData$(body): Observable<any> {
    const token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'partner/get-partner-data', body, {
        headers: headers
      })
      .catch(this.handleErrorObservable);

  }

  getPartnerDataHash$(body): Observable<any> {
    const token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'partner/get-partner-data-hash', body, {
        headers: headers
      })
      .catch(this.handleErrorObservable);

  }

  scholarshipAcceptance$(body): Observable<any> {
    const token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'partner/post-scholarship-acceptance', body, {
        headers: headers
      })
      .catch(this.handleErrorObservable);

  }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/form-done.service.ts